import * as Sentry from '@sentry/vue';
import StorageHelper from '@/utils/storage-helper';

// import router from '@/router';

const safeLocalStorage = () => {
	try {
		const ls = window.localStorage;
		return ls;
	} catch (err) {
		// Handle no local storage here.
		// Try to redirect router to correct page
		// Report to sentry
		Sentry.captureException(err);
		return null;
	}
};

const ls = safeLocalStorage();
/**
 * Storage wrapper class to storage class to be used around the project - by default localStorage if not creating Storage object
 * used to add to key the env prefix
 * https://developer.mozilla.org/en-US/docs/Web/API/Storage
 */
function stg() {
	return {
		storage: ls,
		// key(index) {
		// 	return this.storage.key(index);
		// },
		isAvailable() {
			return !!this.storage;
		},
		getItem(key) {
			if (this.storage) {
				const item = this.storage.getItem(StorageHelper.wrapKey(key));
				try {
					return JSON.parse(item);
				} catch (error) {
					if (error instanceof SyntaxError) {
						// this item was saved before we JSON.stringified all items, lets return it as is
						return item;
					} else {
						throw error;
					}
				}
			}
			return null;
		},
		setItem(key, value) {
			this.storage && this.storage.setItem(StorageHelper.wrapKey(key), JSON.stringify(value));
		},
		removeItem(key) {
			this.storage && this.storage.removeItem(StorageHelper.wrapKey(key));
		},
		// clear() {
		// 	this.storage.clear();
		// },
	};
}

export default stg;
